export const DEVICE_PREVIEW_KEY = 'device-preview';
